/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input[type=radio][_ngcontent-%COMP%]{display:none}\n/*# sourceMappingURL=widget-income-statistics.component.css.map*/"];
export { styles as styles };
